import { Box } from '@common-fe/common-fe';
import styled from 'styled-components';

export const Wrapper = styled(Box)`
  ${({ theme }) => theme.border.bottom.grey6};
`;
